import script from "./TrainersHero.vue?vue&type=script&setup=true&lang=js"
export * from "./TrainersHero.vue?vue&type=script&setup=true&lang=js"

import "./TrainersHero.vue?vue&type=style&index=0&id=db5648fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db5648fa"]])

export default __exports__